import store from './vueX';
import io from 'socket.io-client';

export default function connectSocket(uid) {
    document.cookie = `uid=${uid};path=/;domain=.honsenflag.com`;
    window.socket = io( $conf.socketUrl + '?uid=' + uid );
    socket.on('notification', function (data) {
        store.commit('addNotiData', data);
        // console.log('通知', data);
    });
    // socket.on('chat', function(data){
    //     let type = data.type.substring(0,7);
    //     if(type == 'consult'){
    //         store.commit('changeConsult', data);
    //         console.log('咨询信息', data);
    //     }else{
    //         store.commit('changeSinglechat', data);
    //     }
    // });
    socket.on('chat',function (data) {
        store.commit('changeSinglechat', data);
        // console.log('聊天信息', data);
    });
    socket.on('consult',function (data) {
        store.commit('changeConsult', data);
        // console.log('咨询信息', data);
    });
    socket.on('consult-read',function (data){
        store.commit('changeConsultNum' , data);
        // console.log('咨询未读数',data);
    });
    socket.on('schedure', function (data) {
        store.commit('addSchedure', data);
        // console.log('日程提醒', data);
    });
    socket.on('chatread', function (data) {
        store.commit('changeChatRead', data);
        // console.log('已读', data);
    });
};



// WEBPACK FOOTER //
// ./src/socket.js